import untypedPermissions from "./permissions-list.json";

export type PermissionName = keyof typeof untypedPermissions;

export interface Permission {
  id: string;
  title: string;
  description: string;
  category: string;
  disablePermissions?: string[];
}

export interface PermissionWithName extends Permission {
  name: string;
}

export const permissions = untypedPermissions as Record<PermissionName, Permission>;

export const permissionsById: Record<string, Permission> = Object.values(permissions)
  .reduce((r, x) => ({ ...r, [x.id]: x }), {});

export const permissionsWithNames: PermissionWithName[] = Object.keys(permissions)
  .map((key) => ({ name: key, ...permissions[key as PermissionName] }));
